import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { IRowData } from "../../../../../shared/contracts/IRowData";
import useReportingAndAnalyticsApi from "../../useReportingAndAnalyticsApi";
import IAsyncArgs from "../../../../../shared/contracts/IAsyncArgs";
import useAppStoreHook from "../../../../../shared/context/app-store/useAppStore.hook";

interface PopupProps {
  open: boolean;
  rowData: IRowData;
  onClose: () => void;
  onSubmit: () => void;
}

export const Popup: React.FC<PopupProps> = ({
  open,
  rowData,
  onClose,
  onSubmit,
}) => {
  const { saveReportSubscription } = useReportingAndAnalyticsApi();
  const { userIdGlobally } = useAppStoreHook(); // Use the hook to get the userIdGlobally

  const handleSubmit = async () => {
    const enhancedRowData = {
      ...rowData,
      statusDescription: "Queued",
      dateStarted: "",
      createdDate: new Date().toISOString(),
      taskResult: "",
      reportMetadata: "",
      createdBy: userIdGlobally,
      createdByUserLogin: "", // Set this as userIdGlobally
      updatedByUserLogin: "",
    };

    const asyncArgs: IAsyncArgs<void> = {
      doIf: () => true,
      doAfter: () => {
        onClose();
        onSubmit();
      },
      onFulfilled: (response) => {
        console.log("Report saved successfully", response);
      },
      onException: (error) => {
        console.error("Error saving report", error);
      },
    };

    await saveReportSubscription(enhancedRowData, asyncArgs);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="dialog-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="dialog-title">Add to Queue</DialogTitle>
      <DialogContent>
        <Card sx={{ maxWidth: 545, bgcolor: "background.paper", m: 1 }}>
          <CardContent>
            <Typography
              variant="h5"
              gutterBottom
              component="div"
              color="primary"
            >
              {rowData?.reportName}
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontSize: "1rem" }}
              color="text.secondary"
            >
              Category: {rowData?.category}
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontSize: "1rem" }}
              color="text.secondary"
            >
              Task Status: Queued
            </Typography>
          </CardContent>
        </Card>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="primary">
          Close
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Popup;
